import { useCallback, useState } from 'react';
import { Domain } from '@repo/domain';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { addressPredictionKeys, addressPredictionOptions } from '../../constants/addressPredictions';
import { resolveRepository } from '../../registry/resolveRepository';
export function useAddressPredictionStream() {
    const queryClient = useQueryClient();
    const [filter, setFilter] = useState();
    const [scope, setScope] = useState();
    const { data, isLoading, isSuccess } = useQuery({
        ...addressPredictionOptions.get(filter, scope),
        enabled: !!filter?.query,
    });
    const search = useCallback((nextFilter, nextScope) => {
        setFilter(nextFilter);
        setScope(nextScope);
    }, []);
    const clear = useCallback(async () => {
        setFilter(undefined);
        setScope(undefined);
        const repo = await resolveRepository(Domain.AddressPrediction);
        repo.resetSession();
        queryClient.removeQueries({ queryKey: addressPredictionKeys.all });
    }, [queryClient]);
    return {
        addressPredictions: data ?? [],
        loadingAddressPredictions: isLoading,
        isSuccess,
        search,
        clear,
    };
}
